import ActionHelper from '@wetransfer/transfer/modules/redux-actions';

export const actions = ActionHelper.types(['PAYMENT_ERROR']);

export default ActionHelper.generate({
  setPaymentError: [actions.PAYMENT_ERROR, 'details'],
});
